<template>
    <div>
        <the-banner :title="this.$lang.detailsTitle"
                    :description="data.name"
                    image="cover.jpeg"/>
        <markdown-wrapper class="body-block"
                          id="markdown"
                          :source="data.markdown"/>
    </div>
</template>

<script>
	import TheBanner from "../components/TheBanner";
	import ProductService from "@/services/ProductService";
	import MarkdownWrapper from "@/components/MarkdownWrapper";

	export default {
		name: "Details",
		components: {MarkdownWrapper, TheBanner},
		created() {
			ProductService.getProductInfo(this.$route.params.id).then(result => {
				this.data = result;
			});
		},
		data() {
			return {
				data: {
					name: "",
					markdown: this.$lang.loading
				}
			};
		}
	}
</script>

<style scoped lang="scss">
    #markdown {
        min-height: 70vh;
    }
</style>